'use strict';
/* eslint no-sync: 0 */

import angular from 'angular';

export class NavbarComponent {
  isCollapsed = true;

  constructor(Auth, $state, MENU_CONFIG, PUBLIC_MENU_CONFIG, Config) {
    'ngInject';

    this.isLoggedIn = Auth.isLoggedInSync;
    this.isAdmin = Auth.isAdminSync;
    this.isSuperAdmin = Auth.isSuperAdminSync;

    this.hasRole = Auth.hasRoleSync;

    this.getCurrentUser = Auth.getCurrentUserSync;
    this.$state = $state;

    this.searchterm = null;
    this.searchSubmitted = false;

    this.menu = MENU_CONFIG.data || [];
    this.publicMenu = PUBLIC_MENU_CONFIG.data || [];

    this.showUserMenuLabel = Config.getModuleConfig(Config.Modules.General).showUserMenuLabel();
    this.userMenuLabel = Config.getModuleConfig(Config.Modules.General).getUserMenuLabel();
    this.defaultMenuPermission = Config.getPlatformConfig().getMenuDefaultPermission();
    this.navbarStyle = Config.getPlatformConfig().getNavbarStyle();
    this.navbarContainer = Config.getPlatformConfig().getNavbarContainer();
    this.navbarInterceptor = Config.getPlatformConfig().getNavbarInterceptor();

    this.hasPaymentsActivated = Config.isModuleEnabled(Config.Modules.Payment);

    this.homeImage = Config.getPlatformConfig().getHomeImage();
  }

  getPathHome() {
    return (this.isLoggedIn()) ? "/home" : "/";
  }

  hasPermission(menuEntry) {
    let allowedRoles = [];

    if (angular.isArray(menuEntry.permission)) {
      allowedRoles = menuEntry.permission;
    } else if (typeof menuEntry.permission == 'string') {
      allowedRoles = [menuEntry.permission];
    } else if (this.defaultMenuPermission) {
      allowedRoles = [this.defaultMenuPermission];
    } else {
      return false;
    }

    for (let role of allowedRoles) {
      if (this.hasRole(role)) {
        return true;
      }
    }

    return false;
  }

  search(form) {
    this.searchSubmitted = true;

    if(form.$valid) {
      this.searchSubmitted = false;
      this.$state.go('search-result',{searchterm: this.searchterm});
    }
  }

}

export default angular.module('directives.navbar', [])
  .component('navbar', {
    template: require('./navbar.html'),
    controller: NavbarComponent
  })
  .name;



// WEBPACK FOOTER //
// ./client/components/navbar/navbar.component.js